module.exports = __webpack_public_path__ + "img/DS-M-10.0b2f6cf5.svg";